<template>
    <div>
      <!-- Pasa la prop solo si la copia está completa -->
      <TableComponent v-if="isCopyComplete" :items="localItemsArray" :columns="columns" @nextModalAnuladosvsConsolidadop2="nextModalAnuladosvsConsolidadop2" ref="tableData" />
    </div>
  </template>

<script>
import TableComponent from './table4.vue'

export default {
  components: {
    TableComponent,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      columns: ['CobraComisionCon', 'Observaciones', 'Periodo', 'Id Banner', 'Documento','Número Orden', '¿Eliminar?'],
      localItemsArray: [],
      isCopyComplete: false, // Indica si se completó la copia
    }
  },
  mounted () {
    this.localItems() 
  },
  methods: {
    localItems () {
      this.localItemsArray = this.items.map(item => ({
        ...item, // Copia las propiedades existentes
        eliminar: '', // Añade la nueva propiedad
      }))
      this.isCopyComplete = true // Marca que la copia se completó
    },
    callTableSon () {
      this.$refs.tableData.sendDataOperators()
    },
    nextModalAnuladosvsConsolidadop2(){
      this.$emit('nextModalAnuladosvsConsolidadop2')
    }
  },
}
</script>